<template>
<div class="creature-heading">
  <div class="creature-heading-row">
    <h1>{{name}}</h1>
    <h2>Level {{level}} {{role | capitalize}}</h2>
  </div>
  <div class="creature-heading-row">
    <h1>{{detail}}</h1>
    <h2>{{type | capitalize}}</h2>
  </div>
</div>
</template>

<script>
export default {
  props: ['name', 'level', 'role', 'detail', 'type'],
  filters: {
    capitalize(value) {
      if(!value) return ''
      value = value.toString()
      return value[0].toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style lang="scss">
.creature-block {
  .creature-heading-row {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    align-items: flex-end;
    align-content: space-between;

    h1, h2 {
      font-weight: bold;
      font-style: normal;
      margin: 0;
      font-size: 1em;
    }

    h2 {
      margin-left: auto;
    }

    &:nth-child(1) h1 {
      font-size: 1.4em;
    }

    &:nth-child(2) {
      font-size: 0.9em;
      h1 {
        font-weight: normal;
        font-style: italic;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/creature-header.vue